export default __webpack_public_path__ + "static/media/32.83f22417.jpg";